import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Link, SidebarModal, Text,
} from '@domain-group/suit-theme'

import useContact from '@hooks/useContact'

interface ContactItemProps {
  callbacks: {
    removeContact: () => void,
  },
  contactId: number,
}

const ContactItem = (props: ContactItemProps) => {
  const { callbacks: { removeContact }, contactId } = props

  const { contact } = useContact({ id: contactId }, { performHttpRequests: !!contactId })
  const {
    email, full_name, id, mobile,
  } = contact || {}

  return (
    <SidebarModal.User
      disableHover
      key={id}
      subtitle={email || 'No Mobile'}
      title={full_name || 'Deleted User'}
    >
      <Box justifyContent="flex-end">
        <Text color="bodyFontLightColor" fontSize="xsmall">
          {mobile}
        </Text>
      </Box>

      <Link greyLink onClick={() => removeContact()} textProps={{ marginLeft: 'medium' }}>
        <FontAwesomeIcon icon={faTrashAlt} />
      </Link>
    </SidebarModal.User>
  )
}

export default ContactItem
